(function (root) {
  'use strict';
  const eligibleHandles = ['zen', 'chargeur-chaton', 'mochi', 'pelican', 'echo', 'satellite-copy', 'le-carre', 'zen-copy', 'pinky', 'etreinte-gris', 'echo-copy', 'chargeur-arcade', 'chargeur-perchoir', 'ligne', 'chargeur-porte-casque', 'spade', 'le-voyageur', 'porte-casque', 'perchoir2'];
  const offerCounts = { solo: 1, duo: 2 };
  function quote(catalogue, selection) {
    const count = offerCounts[selection.mode];
    const ids = selection.variants || [selection.first, ...(count > 1 ? [selection.second] : [])];
    if (!count || ids.length !== count) throw new Error('Choisissez chaque chargeur du pack.');
    const chosen = ids.map(id => {
      const product = catalogue.find(product => product.variants.some(variant => String(variant.id) === String(id)));
      const variant = product?.variants.find(variant => String(variant.id) === String(id));
      if (!variant || !variant.available) throw new Error('Cette variante est indisponible.');
      return { product, variant };
    });
    const subtotal = chosen.reduce((total, unit) => total + unit.variant.price, 0);
    const eligible = chosen.filter(unit => eligibleHandles.includes(unit.product.handle)).length;
    const saving = eligible >= 2 ? chosen.reduce((total, unit) => total + Math.floor(unit.variant.price * 20 / 100), 0) : 0;
    const items = [];
    chosen.forEach(({ variant }) => {
      const item = items.find(item => item.id === variant.id);
      if (item) item.quantity++;
      else items.push({ id: variant.id, quantity: 1 });
    });
    if (count > 1) items.push({ id: 56083985006937, quantity: 1 });
    return { total: subtotal - saving, subtotal, saving, items };
  }
  // Manufacturer model capabilities checked 27 October 2026; they are not measured Chaton output.
  const module15Qi2 = true;
  const phoneCatalogue = [];
  const phoneProfiles = {};
  function addPhones(brand, models, profile, receiver, magnets, max) {
    phoneProfiles[profile] = { receiver, magnets, max };
    models.forEach(name => phoneCatalogue.push({ id: name.toLowerCase().replace(/\+/g, ' plus').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''), name, brand, profile }));
  }
  addPhones('Apple', ['iPhone 12', 'iPhone 12 Pro', 'iPhone 12 Pro Max', 'iPhone 13', 'iPhone 13 Pro', 'iPhone 13 Pro Max', 'iPhone 14', 'iPhone 14 Plus', 'iPhone 14 Pro', 'iPhone 14 Pro Max', 'iPhone 15', 'iPhone 15 Plus', 'iPhone 15 Pro', 'iPhone 15 Pro Max', 'iPhone 17e'], 'iphone-qi2-15', 'Qi2', true, 15);
  addPhones('Apple', ['iPhone 12 mini', 'iPhone 13 mini'], 'iphone-mini', 'Qi2 supported with current software', true, null);
  addPhones('Apple', ['iPhone 16', 'iPhone 16 Plus', 'iPhone 17', 'iPhone 17 Pro', 'iPhone 17 Pro Max', 'iPhone 18 Pro', 'iPhone 18 Pro Max'], 'iphone-qi2-25', 'Qi2', true, 25);
  addPhones('Apple', ['iPhone 16 Pro', 'iPhone 16 Pro Max'], 'iphone-qi2-25', 'Qi2', true, 25);
  addPhones('Apple', ['iPhone Air'], 'iphone-air', 'Qi2', true, 20);
  addPhones('Apple', ['iPhone Duo'], 'iphone-duo', 'Qi2', true, 25);
  addPhones('Apple', ['iPhone 8', 'iPhone 8 Plus', 'iPhone X', 'iPhone XS', 'iPhone XS Max', 'iPhone XR', 'iPhone 11', 'iPhone 11 Pro', 'iPhone 11 Pro Max', 'iPhone SE (2020)', 'iPhone SE (2022)', 'iPhone 16e'], 'iphone-qi-no-magnets', 'Qi1.x', false, null);
  addPhones('Apple', ['iPhone 7', 'iPhone 7 Plus', 'iPhone SE (2016)'], 'apple-no-qi', 'none', false, 0);
  addPhones('Samsung', ['Samsung Galaxy S20', 'Samsung Galaxy S20+', 'Samsung Galaxy S20 Ultra', 'Samsung Galaxy S21', 'Samsung Galaxy S21+', 'Samsung Galaxy S21 Ultra', 'Samsung Galaxy S22', 'Samsung Galaxy S22+', 'Samsung Galaxy S22 Ultra', 'Samsung Galaxy S23', 'Samsung Galaxy S23+', 'Samsung Galaxy S23 Ultra', 'Samsung Galaxy S24', 'Samsung Galaxy S24+', 'Samsung Galaxy S24 Ultra', 'Samsung Galaxy S20 FE', 'Samsung Galaxy S20 FE 5G', 'Samsung Galaxy S21 FE', 'Samsung Galaxy S21 FE 5G', 'Samsung Galaxy S23 FE', 'Samsung Galaxy S24 FE'], 'samsung-legacy-qi', 'Qi1.x', false, null);
  addPhones('Samsung', ['Samsung Galaxy S25', 'Samsung Galaxy S25+', 'Samsung Galaxy S25 Ultra', 'Samsung Galaxy S25 FE', 'Samsung Galaxy S25 Edge'], 'samsung-s25-qi2ready', 'Qi2 Ready with certified matched case', false, 15);
  addPhones('Samsung', ['Samsung Galaxy S26', 'Samsung Galaxy S26 FE'], 'samsung-s26-15', 'Qi2 Ready with certified matched case', false, 15);
  addPhones('Samsung', ['Samsung Galaxy S26+'], 'samsung-s26-plus', 'Qi2 Ready with certified matched case', false, 20);
  addPhones('Samsung', ['Samsung Galaxy S26 Ultra'], 'samsung-s26-ultra', 'Qi2 Ready with certified matched case', false, 25);
  addPhones('Samsung', ['Samsung Galaxy Z Fold7', 'Samsung Galaxy Z Flip7'], 'samsung-foldables-qi2ready', 'Qi2 Ready with certified matched case', false, null);
  addPhones('Samsung', ['Samsung Galaxy Z Flip', 'Samsung Galaxy Z Flip 5G', 'Samsung Galaxy Z Flip3', 'Samsung Galaxy Z Flip4', 'Samsung Galaxy Z Flip5', 'Samsung Galaxy Z Flip6', 'Samsung Galaxy Z Flip7 FE', 'Samsung Galaxy Z Flip8', 'Samsung Galaxy Z Fold', 'Samsung Galaxy Z Fold2', 'Samsung Galaxy Z Fold3', 'Samsung Galaxy Z Fold4', 'Samsung Galaxy Z Fold5', 'Samsung Galaxy Z Fold6', 'Samsung Galaxy Z TriFold'], 'samsung-foldables-exact-model-needed', 'Qi verified; exact magnetic protocol unresolved', null, null);
  addPhones('Samsung', ['Samsung Galaxy Z Fold8'], 'samsung-fold8', 'Qi2 Ready with certified matched case', false, 20);
  addPhones('Samsung', ['Samsung Galaxy Z Fold8 Ultra'], 'samsung-fold8-ultra', 'Qi2 Ready with certified matched case', false, null);
  addPhones('Google', ['Google Pixel 10', 'Google Pixel 10 Pro', 'Google Pixel 10 Pro Fold'], 'pixel-qi2-15', 'Qi2', true, 15);
  addPhones('Google', ['Google Pixel 10 Pro XL', 'Google Pixel 11', 'Google Pixel 11 Pro', 'Google Pixel 11 Pro XL', 'Google Pixel 11 Pro Fold'], 'pixel-qi2-25', 'Qi2', true, 25);
  addPhones('Google', ['Google Pixel 3', 'Google Pixel 3 XL', 'Google Pixel 4', 'Google Pixel 4 XL', 'Google Pixel 5', 'Google Pixel 6', 'Google Pixel 6 Pro', 'Google Pixel 7', 'Google Pixel 7 Pro', 'Google Pixel 7a', 'Google Pixel 8', 'Google Pixel 8 Pro', 'Google Pixel 8a', 'Google Pixel Fold', 'Google Pixel 9', 'Google Pixel 9 Pro', 'Google Pixel 9 Pro XL', 'Google Pixel 9 Pro Fold', 'Google Pixel 9a'], 'pixel-legacy-qi', 'Qi1.x', false, null);
  addPhones('Google', ['Google Pixel 10a'], 'pixel-10a-qi', 'Qi1.x; explicitly not Qi2', false, null);
  addPhones('Google', ['Google Pixel 3a', 'Google Pixel 3a XL', 'Google Pixel 4a', 'Google Pixel 4a 5G', 'Google Pixel 5a', 'Google Pixel 5a 5G', 'Google Pixel 6a'], 'pixel-no-qi', 'none', false, 0);
  addPhones('Samsung', ['Samsung Galaxy A', 'Samsung Galaxy M', 'Samsung Galaxy XCover'], 'samsung-no-qi', 'none', false, 0);
  function compatibility(id, caseType, productLabel = 'ce modèle') {
    const phone = phoneCatalogue.find(phone => phone.id === id);
    const profile = phoneProfiles[phone?.profile];
    const result = {
      name: phone?.name || 'Votre téléphone', status: 'identify', title: 'Retrouvez votre modèle', recommendation: '', limit: '',
      charge: 'Ouvrez les réglages pour retrouver le nom du modèle de votre téléphone.',
      magnet: '',
      power: 'La puissance reçue dépend du téléphone, de sa version logicielle, de la coque et de l’adaptateur. Les versions 15 W et 25 W ne garantissent pas ces débits sur chaque appareil.',
      next: 'Choisissez ensuite le groupe correspondant à ce nom.'
    };
    if (!profile) return result;
    if (profile.receiver === 'none') {
      return { ...result, status: 'incompatible', title: 'Non compatible', recommendation: 'Aucune version', charge: 'Ce modèle ne possède pas la charge sans fil Qi intégrée.', magnet: 'Ajouter une coque ne crée pas la charge sans fil.', next: 'Choisissez une solution de charge filaire pour ce téléphone.' };
    }
    if (/Fold|Flip/.test(phone.name)) result.usage = 'À utiliser plié.';
    if (phone.brand !== 'Apple' && !profile.magnets) {
      const certified = profile.receiver.includes('Ready') && caseType === 'qi2-ready';
      const fitted = ['magnetic','qi2-ready'].includes(caseType);
      const higher = certified && (profile.max > 15 || phone.profile === 'samsung-fold8-ultra');
      return { ...result, status: fitted ? 'compatible' : 'requires-case', title: fitted ? 'Compatible' : 'Coque magnétique obligatoire', recommendation: higher ? '25 W' : '15 W', charge: certified ? 'Ce téléphone utilise Qi2 avec une coque Qi2 Ready certifiée pour ce modèle.' : 'Ce téléphone utilise la charge sans fil Qi standard avec une coque magnétique adaptée.', magnet: certified ? 'Une coque Qi2 Ready certifiée pour ce modèle est nécessaire.' : 'Une coque magnétique adaptée à ce modèle est obligatoire.', limit: certified && profile.max ? 'Téléphone : jusqu’à ' + profile.max + ' W selon les conditions.' : '', next: certified ? 'Version ' + (higher ? '25 W' : '15 W') + ' recommandée pour le mode Qi2 avec cette coque certifiée.' : '' };
    }
    if (phone.profile === 'iphone-qi-no-magnets') {
      return { ...result, status: caseType === 'magnetic' ? 'compatible' : 'requires-case', title: caseType === 'magnetic' ? 'Compatible' : 'Coque MagSafe obligatoire', recommendation: '15 W', charge: 'Ce téléphone possède la charge sans fil Qi. La version ' + productLabel + ' 15 W convient avec une coque MagSafe adaptée.', magnet: 'Une coque MagSafe adaptée à votre iPhone est obligatoire.', next: caseType === 'magnetic' ? 'Compatible avec votre coque MagSafe.' : 'Prévoyez une coque MagSafe.' };
    }
    const ready = profile.receiver.includes('Ready');
    const faster = profile.max > 15;
    result.status = 'compatible';
    result.title = 'Compatible';
    result.recommendation = faster || module15Qi2 !== true ? '25 W' : '15 W';
    result.charge = 'Ce téléphone prend en charge Qi2' + (ready ? ' avec une coque Qi2 Ready certifiée pour ce modèle.' : '.') + ' Les ' + productLabel + ' 15 W et 25 W prennent en charge Qi2.';
    result.magnet = ready ? 'Une coque Qi2 Ready certifiée pour ce modèle est nécessaire.' : caseType === 'none' ? 'Sans coque : les aimants du téléphone assurent la fixation.' : 'Utilisez une coque MagSafe ou Qi2 adaptée à votre téléphone.';
    result.limit = profile.max ? 'Téléphone : jusqu’à ' + profile.max + ' W selon les conditions.' : '';
    result.next = faster ? 'Version 25 W recommandée pour couvrir la capacité Qi2 de ce téléphone. Ce maximum fabricant ne constitue pas un débit ' + productLabel + ' mesuré.' : module15Qi2 === true ? 'La version 15 W convient à ce téléphone ; aucun gain de vitesse n’est établi ici avec la version 25 W.' : 'Les deux versions prennent en charge Qi2. Ce téléphone reste limité à sa propre puissance de charge.';
    if (phone.profile === 'iphone-mini') result.next += ' Gardez iOS à jour ; le débit propre au ' + productLabel + ' sur les modèles mini n’a pas été mesuré.';
    if (ready && caseType !== 'qi2-ready') {
      result.status = 'requires-case';
      result.title = 'Coque Qi2 Ready obligatoire';
      result.magnet = 'Une coque Qi2 Ready certifiée pour ce modèle est obligatoire.';
      result.next = '';
    } else if (caseType === 'ordinary' || caseType === 'unknown') {
      result.status = 'requires-case';
      result.title = 'Coque à adapter';
      result.magnet = 'Retirez votre coque ou utilisez une coque magnétique adaptée à ce modèle.';
      result.next = 'Adaptez votre coque avant d’utiliser le ' + productLabel + '.';
    }
    return result;
  }
  function galleryTarget(creatives, color, currentIndex) {
    const target = creatives.findIndex(creative => creative.color === color);
    return target >= 0 ? target : currentIndex;
  }
  function carouselStops(count, step, maximum) {
    return Array.from(new Set(Array.from({ length: count }, (_, index) => Math.round(Math.min(index * step, maximum)))));
  }
  function mount(page) {
    const catalogue = JSON.parse(page.querySelector('[data-catalogue]').textContent);
    const modelPreviews = JSON.parse(page.querySelector('[data-model-previews]').textContent);
    const find = selector => page.querySelector(selector);
    const status = find('[data-status]');
    const form = find('.sm-offer-form');
    root.LPCSmoocheRouting.initializeOffer(form, root.location.search);
    const add = find('[data-add]');
    const configurator = find('#sm-configurator');
    const confirm = find('[data-confirm]');
    const currency = page.dataset.currency || 'EUR';
    const money = value => new Intl.NumberFormat('fr-FR', { style: 'currency', currency }).format(value / 100);
    const primaryHandle = page.dataset.primaryHandle;
    const productLabel = page.dataset.productLabel;
    const firstProduct = catalogue.find(product => product.handle === primaryHandle);
    if (!firstProduct?.variants.length) {
      status.textContent = 'Ce modèle est indisponible. Rechargez sa fiche produit.';
      add.disabled = true;
      form.addEventListener('submit', event => event.preventDefault());
      return;
    }
    const defaultVariant = root.LPCSmoocheRouting.initialVariant(firstProduct.variants, page.dataset.initialVariant, root.location.search);
    const units = Array.from({ length: 2 }, () => defaultVariant.id);
    let activeUnit = 0;
    let modelPickerOpen = false;
    let busy = false;
    const mode = () => form.querySelector('[name="offer"]:checked').value;
    const count = () => offerCounts[mode()];
    const selectionState = (offer = mode()) => ({ variants: units.slice(0, offerCounts[offer]), mode: offer, currency });
    const chosenUnit = index => {
      const product = catalogue.find(product => product.variants.some(variant => String(variant.id) === String(units[index])));
      return { product, variant: product.variants.find(variant => String(variant.id) === String(units[index])) };
    };
    const colorOf = variant => variant.color || variant.options?.[0] || variant.title.split(' / ')[0];
    const powerOf = variant => variant.power || variant.options?.[1] || variant.title.split(' / ')[1] || '15W';
    const element = (tag, text, className) => {
      const node = document.createElement(tag);
      if (text) node.textContent = text;
      if (className) node.className = className;
      return node;
    };
    function imageFor(product, variant, alt) {
      const img = element('img');
      const src = variant?.image || product.image;
      if (src) img.src = src;
      img.alt = alt || product.title;
      img.width = 120;
      img.height = 120;
      img.loading = 'lazy';
      return img;
    }
    function choice(label, selected, disabled, handler) {
      const button = element('button');
      button.type = 'button';
      button.setAttribute('aria-label', label);
      button.setAttribute('aria-pressed', String(selected));
      button.disabled = disabled;
      button.addEventListener('click', handler);
      return button;
    }
    function focusChoice(selector, value) {
      const target = Array.from(page.querySelectorAll(selector)).find(button => button.dataset.choice === value);
      target?.focus({ preventScroll: true });
    }
    function renderModels() {
      const products = catalogue.slice().sort((a, b) => Number(b.handle === primaryHandle) - Number(a.handle === primaryHandle));
      const current = chosenUnit(activeUnit);
      find('.sm-config-models').hidden = !modelPickerOpen;
      if (find('.sm-config-models').hidden) { find('[data-model-grid]').replaceChildren(); return; }
      find('[data-model-grid]').replaceChildren(...products.map(product => {
        const available = product.variants.find(variant => variant.available);
        const button = choice(product.title + (available ? '' : ' — indisponible'), current.product.handle === product.handle, !available && product.handle !== 'silhouette', () => {
          if (!available && product.handle === 'silhouette') { root.location.assign((page.dataset.root || '/') + 'products/silhouette?view=lpc-smooche-silhouette'); return; }
          units[activeUnit] = current.product.handle === product.handle && current.variant.available ? current.variant.id : available.id;
          modelPickerOpen = false;
          updateConfiguration();
          find('[data-config-scroll]').scrollTop = 0;
          find('[data-model-toggle]').focus({ preventScroll: true });
        });
        button.dataset.choice = product.handle;
        button.append(imageFor({ ...product, image: modelPreviews[product.handle] }, null), element('strong', product.title), element('small', available ? product.type : 'Indisponible'));
        return button;
      }));
    }
    function renderConfigurator(selection) {
      activeUnit = Math.min(activeUnit, count() - 1);
      configurator.dataset.count = String(count());
      find('#sm-config-title').textContent = modelPickerOpen ? 'Choisir un modèle' : count() === 1 ? 'Votre chargeur' : 'Votre ' + (activeUnit === 0 ? '1er' : '2e') + ' chargeur';
      find('[data-config-step]').textContent = !modelPickerOpen && count() === 2 ? (activeUnit + 1) + ' sur 2' : '';
      find('[data-config-back]').hidden = activeUnit === 0 || modelPickerOpen;
      find('[data-model-close]').hidden = !modelPickerOpen;
      find('.sm-config-product').hidden = modelPickerOpen;
      find('.sm-config-footer').hidden = modelPickerOpen;
      page.querySelectorAll('.sm-config-options>fieldset:not(.sm-config-models)').forEach(fieldset => { fieldset.hidden = modelPickerOpen; });
      const { product, variant } = chosenUnit(activeUnit);
      const preview = find('[data-unit-image]');
      preview.src = variant.image || product.image || '';
      preview.alt = variant.imageLabel || product.title + ' — ' + colorOf(variant);
      const photoNote=find('[data-variant-photo-note]');if(photoNote){const note=variant.imageNote||'';photoNote.textContent=note;photoNote.hidden=!note;photoNote.style.display=note?'':'none';}
      find('[data-unit-name]').textContent = product.title;
      find('[data-unit-name]').toggleAttribute('data-long-name', product.title.length > 12);
      find('[data-model-peeks]').replaceChildren(...['zen', 'cascade-2024', 'chargeur-morpho'].filter(handle => modelPreviews[handle]).map(handle => {
        const image = document.createElement('img');
        image.src = modelPreviews[handle];
        image.alt = '';
        image.dataset.modelPeek = handle;
        return image;
      }));
      find('[data-model-toggle]').setAttribute('aria-expanded', String(modelPickerOpen));
      find('[data-config-gifts]').hidden = count() === 1 || modelPickerOpen;
      renderModels();
      find('[data-current-color]').textContent = colorOf(variant);
      const colors = Array.from(new Set(product.variants.map(colorOf)));
      find('[data-color-grid]').replaceChildren(...colors.map(color => {
        const variants = product.variants.filter(option => colorOf(option) === color);
        const available = variants.find(option => option.available && powerOf(option) === powerOf(variant)) || variants.find(option => option.available);
        const button = choice(color + (available ? '' : ' — indisponible'), colorOf(variant) === color, !available, () => {
          units[activeUnit] = available.id;
          updateConfiguration();
          focusChoice('[data-color-grid] button', color);
        });
        button.dataset.choice = color;
        const label = element('span', color, 'sm-sr');
        const swatch = element('i', '', 'sm-color-swatch');
        swatch.dataset.color = color.toLocaleLowerCase('fr');
        swatch.setAttribute('aria-hidden', 'true');
        button.append(swatch, label);
        return button;
      }));
      const powers = Array.from(new Set(product.variants.map(powerOf)));
      find('[data-power-grid]').replaceChildren(...powers.map(power => {
        const option = product.variants.find(option => colorOf(option) === colorOf(variant) && powerOf(option) === power);
        const button = choice(power + (option?.available ? '' : ' — indisponible'), powerOf(variant) === power, !option?.available, () => {
          units[activeUnit] = option.id;
          updateConfiguration();
          focusChoice('[data-power-grid] button', power);
        });
        button.dataset.choice = power;
        button.append(element('strong', power.replace('W', ' W')), element('b', option ? money(option.price) : 'Non disponible'), element('small', option?.available ? '' : 'Indisponible'));
        return button;
      }));
      find('[data-config-original]').hidden = count() !== 2 || !selection?.saving;
      find('[data-config-original]').textContent = count() === 2 && selection?.saving ? money(selection.subtotal) : '';
      find('[data-config-total]').textContent = selection ? money(selection.total) : 'Sélection à vérifier';
      confirm.textContent = busy ? 'Vérification et ajout…' : count() === 2 && activeUnit === 0 ? 'Choisir le 2ᵉ chargeur' : 'Ajouter au panier';
      confirm.disabled = busy || (!selection && (count() === 1 || activeUnit === 1));
    }
    function updateConfiguration() {
      find('[data-config-status]').textContent = '';
      render();
    }
    function render() {
      let selection;
      try { selection = quote(catalogue, selectionState()); }
      catch (error) { find('[data-config-status]').textContent = error.message; }
      for (const offer of Object.keys(offerCounts)) {
        try {
          const offerQuote = quote(catalogue, selectionState(offer));
          find('[data-' + offer + '-price]').textContent = money(offerQuote.total);
          if (offer === 'solo') continue;
          find('[data-' + offer + '-original]').textContent = offerQuote.saving ? money(offerQuote.subtotal) : '';
          const chip = find('[data-' + offer + '-chip]');
          chip.hidden = !offerQuote.saving;
          chip.textContent = '−' + money(offerQuote.saving);
          find('[data-saving]').textContent = offerQuote.saving ? 'Deux espaces équipés, ' + money(offerQuote.saving) + ' économisés.' : 'Deux modèles à votre image.';
          find('.sm-duo-tag').hidden = !offerQuote.saving;
          root.LPCSmoocheRouting.renderDuoPrice?.(page, offerQuote, [chosenUnit(0).variant.price, chosenUnit(1).variant.price], currency);
        } catch (error) {
          find('[data-' + offer + '-price]').textContent = 'À vérifier';
          if (offer === 'duo') {
            find('[data-duo-original]').textContent = '';
            find('[data-duo-chip]').textContent = '';
            find('[data-duo-chip]').hidden = true;
            find('.sm-duo-tag').hidden = true;
            find('[data-saving]').textContent = 'Deux modèles à votre image.';
          }
        }
      }
      const firstUnit = chosenUnit(0);
      find('[data-first-price]').textContent = selection ? money(selection.total) : 'À vérifier';
      find('[data-price-label]').textContent = count() > 1 ? '2 chargeurs' : '1 chargeur';
      find('[data-price-label]').hidden = count() === 1;
      find('[data-delivery-benefit]').textContent = page.dataset.country === 'FR' && currency === 'EUR' && selection?.total >= 5000 ? '🇫🇷 | Livraison offerte' : 'Livraison selon destination';
      find('[data-price-original]').hidden = !selection?.saving;
      find('[data-price-original]').textContent = selection?.saving ? money(selection.subtotal) : '';
      find('[data-total]').textContent = selection ? money(selection.total) : 'À vérifier';
      find('[data-sticky-original]').hidden = !selection?.saving;
      find('[data-sticky-original]').textContent = selection?.saving ? money(selection.subtotal) : '';
      const currentIndex = galleryIndex();
      const target = galleryTarget(gallerySlides.map(slide => ({ color: slide.querySelector('img')?.dataset.color || '' })), colorOf(firstUnit.variant), currentIndex);
      if (firstUnit.product.handle === primaryHandle && target !== currentIndex) setGallery(target);
      find('[data-sticky] > img').src = firstUnit.variant.image || firstUnit.product.image || '';
      find('[data-sticky] > img').alt = firstUnit.product.title + ' — ' + firstUnit.variant.title;
      find('[data-sticky-name]').textContent = firstUnit.product.title;
      // Expose the displayed selection for the parcel FAQ without changing cart state.
      page.smParcelSelection = units.slice(0, count()).map((id, index) => { const unit = chosenUnit(index); return { name: unit.product.title, variant: unit.variant.title, image: unit.variant.image || unit.product.image }; });
      page.dispatchEvent(new CustomEvent('sm:parcel-selection', { detail: page.smParcelSelection }));
      renderConfigurator(selection);
    }
    form.querySelectorAll('[name="offer"]').forEach(radio => radio.addEventListener('change', updateConfiguration));
    function selectUnit(index) {
      activeUnit = index;
      modelPickerOpen = false;
      find('[data-config-gifts]').open = false;
      updateConfiguration();
      find('[data-config-scroll]').scrollTop = 0;
    }
    find('[data-config-back]').addEventListener('click', () => {
      if (busy) return;
      selectUnit(0);
      confirm.focus({ preventScroll: true });
    });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (busy) return;
      status.textContent = '';
      find('[data-config-status]').textContent = '';
      selectUnit(0);
      configurator.showModal();
      find('[data-config-scroll]').scrollTop = 0;
    });
    find('[data-model-toggle]').addEventListener('click', () => {
      modelPickerOpen = !modelPickerOpen;
      updateConfiguration();
      if (modelPickerOpen) {
        find('[data-config-scroll]').scrollTop = 0;
        find('[data-model-close]').focus({ preventScroll: true });
      } else {
        find('[data-config-scroll]').scrollTop = 0;
        find('[data-model-toggle]').focus({ preventScroll: true });
      }
    });
    find('[data-model-close]').addEventListener('click', () => {
      modelPickerOpen = false;
      updateConfiguration();
      find('[data-config-scroll]').scrollTop = 0;
      find('[data-model-toggle]').focus({ preventScroll: true });
    });
    configurator.addEventListener('keydown', event => {
      if (event.key !== 'Tab') return;
      const controls = Array.from(configurator.querySelectorAll('button, a[href], input, select, textarea, summary, [tabindex]')).filter(control => !control.disabled && control.tabIndex >= 0 && control.getClientRects().length && root.getComputedStyle(control).visibility !== 'hidden');
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    configurator.addEventListener('close', () => {
      modelPickerOpen = false;
    });
    confirm.addEventListener('click', async () => {
      if (busy || confirm.disabled) return;
      if (count() === 2 && activeUnit === 0) {
        selectUnit(1);
        find('[data-config-back]').focus({ preventScroll: true });
        return;
      }
      busy = true;
      confirm.disabled = true;
      confirm.textContent = 'Vérification et ajout…';
      const configStatus = find('[data-config-status]');
      configStatus.textContent = '';
      const submitState = selectionState();
      const lockedControls = Array.from(page.querySelectorAll('.sm-offer-form input, #sm-configurator button, #sm-configurator input')).map(control => ({ control, disabled: control === confirm ? false : control.disabled }));
      lockedControls.forEach(({ control }) => { control.disabled = true; });
      let cartAttempted = false;
      try {
        const selectedHandles = new Set(submitState.variants.map(id => catalogue.find(product => product.variants.some(variant => String(variant.id) === String(id))).handle));
        const localeRoot = page.dataset.root.endsWith('/') ? page.dataset.root : page.dataset.root + '/';
        const freshProducts = await Promise.all(Array.from(selectedHandles).map(async handle => {
          const response = await fetch(localeRoot + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Impossible de vérifier la disponibilité. Réessayez dans un instant.');
          return response.json();
        }));
        let changed = false;
        freshProducts.forEach(fresh => {
          const existing = catalogue.find(product => product.handle === fresh.handle);
          for (const variant of existing.variants) {
            const actual = fresh.variants.find(v => String(v.id) === String(variant.id));
            if (!actual) { if (variant.available) changed = true; variant.available = false; continue; }
            if (actual.price !== variant.price || actual.available !== variant.available) changed = true;
            variant.price = actual.price;
            variant.available = actual.available;
          }
        });
        const freshSelection = quote(catalogue, submitState);
        if (changed) throw new Error('Le prix ou la disponibilité vient de changer. Vérifiez votre sélection, puis ajoutez-la au panier.');
        if (submitState.variants.length > 1) {
          const response = await fetch(localeRoot + 'products/cadeau-cordon-pour-telephone.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('Le pack cadeau ne peut pas être vérifié. Veuillez réessayer.');
          const gift = (await response.json()).variants.find(v => v.id === 56083985006937);
          if (!gift || !gift.available || gift.price !== 0) throw new Error('Le pack cadeau est actuellement indisponible. Sélectionnez un seul chargeur ou réessayez plus tard.');
        }
        cartAttempted = true;
        const response = await fetch(localeRoot + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: freshSelection.items })
        });
        const result = await response.json();
        if (!response.ok) {
          const error = new Error('L’ajout au panier n’a pas été confirmé.');
          if (response.status >= 400 && response.status < 500 && typeof result.description === 'string') error.merchantMessage = result.description;
          throw error;
        }
        configStatus.textContent = 'Ajouté au panier. Votre total et les remises sont confirmés dans le panier.';
        root.location.assign(page.dataset.cartUrl);
      } catch (error) {
        configStatus.textContent = error.merchantMessage || (cartAttempted ? 'L’ajout n’a pas été confirmé. Vérifiez votre panier avant de réessayer.' : error instanceof TypeError || error instanceof SyntaxError ? 'Impossible de vérifier la disponibilité. Vérifiez votre connexion, puis réessayez.' : error.message);
        const cartLink = element('a', ' Voir mon panier');
        cartLink.href = page.dataset.cartUrl;
        configStatus.append(cartLink);
      } finally {
        busy = false;
        lockedControls.forEach(({ control, disabled }) => { control.disabled = disabled; });
        confirm.textContent = 'Ajouter au panier';
        render();
      }
    });
    const reviewPreviews = Array.from(page.querySelectorAll('.sm-review')).map(card => ({ quote: card.querySelector('[data-review-quote]'), button: card.querySelector('[data-review-toggle]'), context: card.querySelector('[data-review-context]') }));
    function syncReviewPreviews() {
      reviewPreviews.forEach(({ quote, button, context }) => {
        const expanded = button.getAttribute('aria-expanded') === 'true';
        button.hidden = !context && !expanded && quote.scrollHeight <= quote.clientHeight + 1;
      });
    }
    reviewPreviews.forEach(({ quote, button, context }) => {
      quote.classList.add('sm-review-collapsed');
      if (context) context.hidden = true;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        button.textContent = expanded ? 'Réduire' : 'Lire la suite';
        quote.classList.toggle('sm-review-collapsed', !expanded);
        if (context) context.hidden = !expanded;
        syncReviewPreviews();
      });
    });
    new ResizeObserver(syncReviewPreviews).observe(find('#sm-reviews'));
    document.fonts.ready.then(syncReviewPreviews);
    syncReviewPreviews();
    const fitVisuals = JSON.parse(find('[data-fit-visuals]').textContent);
    let fitState = { step: 'brand' };
    const fitHistory = [];
    const fit = find('#sm-fit');
    const fitHeader = fit.querySelector('.sm-fit-header');
    fitHeader.insertBefore(find('[data-fit-question]'), fitHeader.querySelector('[data-close]'));
    fitHeader.append(find('[data-fit-progress]'));
    const shapeOf = phone => /^iPhone (?:16e|17e)$/.test(phone.name) ? 'notch' : /iPhone (?:1[5-9](?!e)|Air|Duo)|iPhone 14 Pro/.test(phone.name) ? 'pill' : /iPhone (?:X|11|12|13|14)/.test(phone.name) ? 'notch' : /iPhone (?:[78]|SE)/.test(phone.name) ? 'home' : 'punch';
    const fitGroups = [];
    const group = (id, brand, label, caption, match, drawing, options = {}) => fitGroups.push({ id, brand, label, caption, members: phoneCatalogue.filter(match), drawing, ...options });
    group('apple-12-15', 'Apple', 'iPhone 12 à 15', 'Mini, Plus, Pro et Pro Max', p => p.brand === 'Apple' && /^iPhone 1[2-5](?: |$)/.test(p.name), 'mixed', { note: 'Les modèles mini demandent un logiciel à jour. Aucun débit propre au ' + productLabel + ' n’a été mesuré sur ces modèles.' });
    group('apple-16-plus', 'Apple', 'iPhone 16 à 18', 'Hors modèles e et Air', p => p.profile === 'iphone-qi2-25', 'pill', { note: 'Sur iPhone 16 et suivants, la capacité Qi2 25 W demande iOS 26 ou plus récent. Cela ne garantit pas 25 W reçus avec le ' + productLabel + '.' });
    group('apple-17e', 'Apple', 'iPhone 17e', '', p => p.name === 'iPhone 17e', 'notch');
    group('apple-air', 'Apple', 'iPhone Air', '', p => p.profile === 'iphone-air', 'pill');
    group('apple-16e', 'Apple', 'iPhone 16e', '', p => p.name === 'iPhone 16e', 'notch');
    group('apple-old-qi', 'Apple', 'iPhone 8 à 11', 'SE 2020 et 2022 inclus', p => p.profile === 'iphone-qi-no-magnets' && p.name !== 'iPhone 16e', 'mixed', { older: true });
    group('apple-old-noqi', 'Apple', 'iPhone 7 / SE 2016', '', p => p.profile === 'apple-no-qi', 'home', { older: true, direct: true });
    group('apple-duo', 'Apple', 'iPhone Duo', '', p => p.profile === 'iphone-duo', 'pill');
    group('samsung-15', 'Samsung', 'Galaxy S25 / S26', 'S25 tous · S26 et S26 FE', p => ['samsung-s25-qi2ready','samsung-s26-15'].includes(p.profile), 'samsung');
    group('samsung-25', 'Samsung', 'Galaxy S26+ / Ultra', '', p => ['samsung-s26-plus','samsung-s26-ultra'].includes(p.profile), 'samsung');
    group('samsung-old', 'Samsung', 'Galaxy S20 à S24', 'Versions FE incluses', p => p.profile === 'samsung-legacy-qi', 'samsung');
    group('samsung-z', 'Samsung', 'Galaxy Z', 'Fold, Flip et TriFold', p => p.brand === 'Samsung' && /Fold|Flip/.test(p.name), 'fold', { children: true });
    group('samsung-noqi', 'Samsung', 'Galaxy A / M / XCover', '', p => p.profile === 'samsung-no-qi', 'samsung', { direct: true });
    group('pixel-15', 'Google', 'Pixel 10 / 10 Pro', 'Hors Pro XL et Fold', p => p.profile === 'pixel-qi2-15' && !p.name.includes('Fold'), 'google');
    group('pixel-25', 'Google', 'Pixel 10 Pro XL / 11', 'Pixel 11, Pro et Pro XL', p => p.profile === 'pixel-qi2-25' && !p.name.includes('Fold'), 'google');
    group('pixel-old', 'Google', 'Pixel 3 à 9', 'Sauf 3a, 4a, 5a et 6a', p => p.profile === 'pixel-legacy-qi' && !p.name.includes('Fold'), 'google', { older: true });
    group('pixel-10a', 'Google', 'Pixel 10a', '', p => p.profile === 'pixel-10a-qi', 'google', { older: true });
    group('pixel-noqi', 'Google', 'Pixel 3a à 6a', '3a, 4a, 5a et 6a', p => p.profile === 'pixel-no-qi', 'google', { older: true, direct: true });
    group('pixel-fold', 'Google', 'Pixel Fold', 'Tous modèles pliants', p => p.brand === 'Google' && p.name.includes('Fold'), 'fold', { children: true });
    group('samsung-z-fold8', 'Samsung', 'Z Fold8 / Fold8 Ultra', '', p => ['samsung-fold8','samsung-fold8-ultra'].includes(p.profile), 'fold', { parent: 'samsung-z' });
    group('samsung-z-other', 'Samsung', 'Autres Galaxy Z', '', p => p.brand === 'Samsung' && /Fold|Flip/.test(p.name) && !['samsung-fold8','samsung-fold8-ultra'].includes(p.profile), 'fold', { parent: 'samsung-z', basicCases: true });
    group('pixel-fold-old', 'Google', 'Pixel Fold / 9 Pro Fold', '', p => ['Google Pixel Fold','Google Pixel 9 Pro Fold'].includes(p.name), 'fold', { parent: 'pixel-fold' });
    group('pixel-fold-10', 'Google', 'Pixel 10 Pro Fold', '', p => p.name === 'Google Pixel 10 Pro Fold', 'fold', { parent: 'pixel-fold' });
    group('pixel-fold-11', 'Google', 'Pixel 11 Pro Fold', '', p => p.name === 'Google Pixel 11 Pro Fold', 'fold', { parent: 'pixel-fold' });
    function fitNext(patch) {
      fitHistory.push({ ...fitState });
      fitState = { ...fitState, ...patch };
      renderFit(true);
    }
    function resetFit(focus = true) {
      fitState = { step: 'brand' };
      fitHistory.length = 0;
      renderFit(focus);
    }
    function fitDrawing(kind) {
      const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 100 112');
      svg.setAttribute('aria-hidden', 'true');
      svg.dataset.fitVisual = kind;
      const shape = (tag, attributes) => {
        const node = document.createElementNS(svg.namespaceURI, tag);
        Object.entries(attributes).forEach(([name, value]) => node.setAttribute(name, value));
        svg.append(node);
        return node;
      };
      const line = { fill: 'none', stroke: 'currentColor', 'stroke-width': 2, 'stroke-linecap': 'round', 'stroke-linejoin': 'round' };
      if (['check', 'adapt', 'verify', 'no'].includes(kind)) {
        shape('circle', { cx: 50, cy: 56, r: 39, fill: 'var(--color-surface-subtle)' });
        shape('path', { ...line, d: kind === 'check' ? 'M30 56l14 14 28-29' : kind === 'no' ? 'M36 42l28 28M64 42L36 70' : kind === 'adapt' ? 'M36 43a20 20 0 1 1-5 24M27 40l9 3-3 10' : 'M40 43a11 11 0 1 1 16 10q-6 3-6 10M50 73v1', 'stroke-width': 4 });
        return svg;
      }
      const phone = (x, y, width, height, style) => {
        shape('rect', { ...line, x, y, width, height, rx: 10, fill: 'var(--color-surface-elevated)' });
        const cx = x + width / 2;
        if (!['samsung','google','ordinary','magnetic','qi2-ready','bare','unknown'].includes(style)) shape('rect', { x: x+4, y: y+4, width: width-8, height: height-8, rx: 7, fill: 'var(--color-primary-container)' });
        if (style === 'home') {
          shape('path', { ...line, d: 'M' + (x+5) + ' ' + (y+17) + 'h' + (width-10) + 'M' + (x+5) + ' ' + (y+height-20) + 'h' + (width-10) });
          shape('circle', { ...line, cx, cy: y+height-10, r: 4 });
        } else if (style === 'notch') shape('path', { ...line, d: 'M' + (cx-15) + ' ' + (y+1) + 'v7q0 5 5 5h20q5 0 5-5v-7', fill: 'currentColor' });
        else if (style === 'pill') shape('rect', { x: cx-12, y: y+8, width: 24, height: 6, rx: 3, fill: 'currentColor' });
        else if (style === 'samsung') [0,1,2].forEach(i => shape('circle', { ...line, cx: x+12, cy: y+14+i*13, r: 4 }));
        else if (style === 'google') { shape('rect', { ...line, x: x+5, y: y+12, width: width-10, height: 14, rx: 7 }); shape('circle', { cx: x+15, cy: y+19, r: 3, fill: 'currentColor' }); }
        else if (style === 'punch') shape('circle', { cx, cy: y+10, r: 3, fill: 'currentColor' });
        else if (style === 'ordinary') shape('rect', { ...line, x: x+5, y: y+5, width: width-10, height: height-10, rx: 7 });
        else if (style === 'magnetic' || style === 'qi2-ready') {
          shape('circle', { ...line, cx, cy: y+height/2, r: 17, 'stroke-width': 3 });
          shape('path', { ...line, d: 'M' + cx + ' ' + (y+height/2+24) + 'v10', 'stroke-width': 3 });
          if (style === 'qi2-ready') shape('path', { ...line, d: 'M' + (cx-8) + ' ' + (y+height/2) + 'l6 6 12-13', 'stroke-width': 3 });
        } else if (style === 'unknown') {
          const text = shape('text', { x: cx, y: y+height/2+10, 'text-anchor': 'middle', fill: 'currentColor', 'font-size': 32, 'font-family': 'inherit' });
          text.textContent = '?';
        }
        if (!['home','samsung','google','ordinary','magnetic','qi2-ready','unknown','bare'].includes(style)) shape('path', { ...line, d: 'M' + (cx-10) + ' ' + (y+height-7) + 'h20' });
      };
      if (kind === 'fold') { phone(9, 15, 82, 88, 'punch'); shape('path', { ...line, d: 'M50 16v86', 'stroke-dasharray': '3 4' }); }
      else if (kind === 'mixed') { phone(10, 11, 48, 94, 'notch'); phone(40, 3, 50, 99, 'pill'); }
      else phone(18, 4, 64, 104, kind === 'apple' ? 'pill' : kind === 'android' ? 'punch' : kind);
      return svg;
    }
    function fitVisual(kind) {
      const image = document.createElement('img');
      image.src = fitVisuals[kind];
      image.alt = '';
      image.width = 256;
      image.height = 256;
      image.decoding = 'async';
      image.dataset.fitVisual = kind;
      return image;
    }
    function renderFit(focus = false) {
      if (fitState.step === 'result' && !fitState.model) fitState.step = 'model-guide';
      const resultView = fitState.step === 'result' || fitState.step === 'unlisted';
      find('[data-fit-step]').hidden = resultView;
      find('[data-phone-result]').hidden = !resultView;
      if (!resultView) { find('[data-phone-result]').replaceChildren(); find('[data-phone-result]').removeAttribute('data-compatibility'); }
      find('[data-fit-back]').hidden = fitHistory.length === 0;
      const hint = find('[data-fit-hint]');
      hint.textContent = '';
      const choices = find('[data-fit-choices]');
      choices.replaceChildren();
      choices.dataset.step = fitState.step;
      delete choices.dataset.caseCount;
      const guide = find('[data-fit-guide]');
      guide.hidden = true;
      const stage = ['brand','android'].includes(fitState.step) ? 1 : ['case','result','unlisted'].includes(fitState.step) ? 3 : 2;
      const title = find('#sm-fit-title');
      title.className = 'sm-sr';
      title.textContent = 'Étape ' + stage + ' sur 3 — ' + (stage === 1 ? 'Téléphone' : stage === 2 ? 'Modèle' : 'Coque et compatibilité');
      let dots = find('[data-fit-progress]');
      if (!dots) {
        dots = element('div', '', 'sm-fit-progress');
        dots.dataset.fitProgress = '';
        dots.setAttribute('aria-hidden', 'true');
        title.before(dots);
      }
      dots.replaceChildren(...[1,2,3].map(index => {
        const dot = element('span');
        if (index === stage) dot.setAttribute('aria-current', 'step');
        return dot;
      }));
      const option = (label, patch, drawing = 'unknown', caption = '') => {
        const button = choice(label, false, false, () => fitNext(patch));
        button.replaceChildren(fitVisual(drawing), element('span', label));
        if (caption) { button.append(element('small', caption)); button.setAttribute('aria-description', caption); }
        button.setAttribute('aria-label', label);
        if (fitState.step === 'identify' && ['notch','pill','home'].includes(drawing)) {
          const image = button.querySelector('[data-fit-visual]');
          image.dataset.phoneDrawing = drawing;
          if (drawing !== 'home') {
            const crop = element('span', '', 'sm-fit-shape-crop');
            image.replaceWith(crop);
            crop.append(image);
          }
        }
        choices.append(button);
      };
      const question = find('[data-fit-question]');
      if (fitState.step === 'brand') {
        question.textContent = 'Quel téléphone utilisez-vous ?';
        option('Apple · iPhone', { step: 'family', brand: 'Apple', family: '', model: '', shape: '', group: '', caseType: '' }, 'apple');
        option('Android', { step: 'android', brand: '', family: '', model: '', shape: '', group: '', caseType: '' }, 'android');
      } else if (fitState.step === 'android') {
        question.textContent = 'Quelle est la marque de votre Android ?';
        ['Samsung','Google'].forEach(brand => option(brand, { step: 'family', brand, family: '', model: '', group: '', caseType: '' }, brand.toLowerCase()));
        option('Autre marque / Je ne sais pas', { step: 'model-guide', brand: '', group: '', model: '', caseType: '' });
      } else if (fitState.step === 'identify') {
        question.textContent = 'À quoi ressemble votre iPhone ?';
        [['Une encoche','notch'],['Un îlot ovale','pill'],['Un bouton rond en bas','home']].forEach(([label,shape]) => option(label, { step: 'family', shape, family: '', model: '', group: '', caseType: '' }, shape));
        option('Je ne sais pas', { step: 'model-guide', group: '', model: '', caseType: '' });
      } else if (fitState.step === 'family' || fitState.step === 'older') {
        question.textContent = 'Quel est votre modèle ?';
        const groups = fitGroups.filter(g => g.brand === fitState.brand && !g.parent && Boolean(g.older) === (fitState.step === 'older') && (!fitState.shape || g.members.some(p => shapeOf(p) === fitState.shape)));
        groups.forEach(g => option(g.label, { step: g.children ? 'fold-family' : g.direct ? 'result' : 'case', group: g.id, model: g.children ? '' : g.members[0]?.id || '', caseType: '' }, g.drawing, g.caption));
        if (fitState.step !== 'older' && fitGroups.some(g => g.brand === fitState.brand && g.older)) option('Plus anciens', { step: 'older', group: '', model: '', caseType: '' }, fitState.brand === 'Apple' ? 'home' : fitState.brand.toLowerCase());
        option(fitState.shape ? 'Je ne trouve pas mon modèle' : 'Je ne sais pas', { step: fitState.brand === 'Apple' && !fitState.shape && fitState.step !== 'older' ? 'identify' : 'model-guide', group: '', model: '', caseType: '' });
        choices.lastElementChild.className = 'sm-fit-unknown';
      } else if (fitState.step === 'fold-family') {
        question.textContent = 'Quel est votre modèle pliant ?';
        fitGroups.filter(g => g.parent === fitState.group).forEach(g => option(g.label, { step: 'case', group: g.id, model: g.members[0]?.id || '', caseType: '' }, g.drawing));
      } else if (fitState.step === 'model-guide') {
        const apple = fitState.brand === 'Apple';
        question.textContent = 'Retrouvez votre modèle';
        hint.textContent = apple ? '' : 'Sur votre Android :';
        const cards = guide.cloneNode(true);
        cards.removeAttribute('data-fit-guide');
        cards.dataset.fitModelGuide = '';
        cards.hidden = false;
        const steps = apple ? [
          ['1 · Ouvrez Réglages','Touchez Général ›'],
          ['2 · Dans Général','Touchez Informations ›'],
          ['3 · Dans Informations','Lisez Nom du modèle','Exemple : iPhone 15']
        ] : [
          ['1 · Ouvrez Paramètres','Touchez l’icône ⚙'],
          ['2 · À propos du téléphone','Ouvrez cette rubrique'],
          ['3 · Lisez le modèle','Nom du modèle','Repérez le nom et la marque']
        ];
        Array.from(cards.children).forEach((card,index) => {
          const [title,row,example] = steps[index];
          card.querySelector('b').textContent = title;
          const mini = card.querySelector('.sm-fit-mini-screen');
          mini.replaceChildren(element('strong',row));
          if (example) mini.append(element('span',example,'sm-fit-example'));
        });
        if (apple && fitVisuals['guide-settings']) {
          cards.classList.add('sm-fit-settings-guide');
          cards.replaceChildren(...[
            ['settings', 'Ouvrez Réglages', 256, 256],
            ['general', 'Touchez Général', 768, 104],
            ['information', 'Touchez Informations', 768, 103],
            ['model', 'Lisez Nom du modèle', 768, 96]
          ].map(([key, label, width, height], index) => {
            const card = element('article');
            const image = element('img');
            image.src = fitVisuals['guide-' + key];
            image.alt = key === 'settings' ? 'Icône Réglages' : label;
            image.width = width;
            image.height = height;
            if (key === 'settings') image.className = 'sm-fit-settings-icon';
            card.append(element('b', (index + 1) + ' · ' + label), image);
            return card;
          }));
        }
        const note = element('p', fitState.group === 'samsung-z' ? 'Le modèle exact détermine la coque certifiée et la tenue sur le ' + productLabel + '. Revenez ensuite aux modèles Samsung.' : fitState.brand ? 'Revenez choisir le groupe correspondant à ce nom.' : 'Retrouvez votre marque, ou choisissez « Mon modèle n’est pas proposé ».', 'sm-fit-guide-note');
        const back = element('button', fitState.brand ? 'J’ai trouvé mon modèle' : 'Revenir aux choix de marques', 'sm-button');
        back.type = 'button';
        back.dataset.fitGuideReturn = '';
        back.addEventListener('click', () => fitNext({ step: fitState.brand ? 'family' : 'android', shape: '', family: '', group: '', model: '', caseType: '' }));
        const notListed = element('button', 'Mon modèle n’est pas proposé', 'sm-fit-unknown sm-fit-reset');
        notListed.type = 'button';
        notListed.dataset.fitNotListed = '';
        notListed.addEventListener('click', () => fitNext({ step: 'unlisted', group: '', model: '', caseType: '' }));
        choices.append(cards);
        if (!apple) choices.append(note);
        choices.append(back,notListed);
      } else if (fitState.step === 'case') {
        question.textContent = 'Utilisez-vous une coque ?';
        hint.textContent = fitGroups.find(g => g.id === fitState.group)?.label || phoneCatalogue.find(phone => phone.id === fitState.model)?.name || '';
        const phone = phoneCatalogue.find(phone => phone.id === fitState.model);
        const ready = phoneProfiles[phone?.profile]?.receiver.includes('Ready') && !fitGroups.find(g => g.id === fitState.group)?.basicCases;
        const cases = ready ? [['Certifiée Qi2 Ready','qi2-ready'],['Coque magnétique','magnetic'],['Sans coque','none'],['Coque classique','ordinary']] : [['Sans coque','none'],[fitState.brand === 'Apple' ? 'Coque MagSafe ou magnétique' : 'Coque magnétique','magnetic'],['Coque classique','ordinary']];
        choices.dataset.caseCount = String(cases.length);
        cases.forEach(([label,caseType]) => option(label, { step: 'result', caseType }, caseType === 'none' ? 'bare' : caseType));
      } else {
        const result = fitState.step === 'unlisted' ? { ...compatibility('', '', productLabel), status: 'not-recommended', title: '' + productLabel + ' non recommandé pour ce modèle', name: 'Modèle non proposé', recommendation: 'Aucune version', next: 'Choisissez un chargeur adapté à votre téléphone.' } : compatibility(fitState.model, fitState.caseType, productLabel);
        const selectedGroup = fitGroups.find(g => g.id === fitState.group);
        if (selectedGroup) {
          result.name = selectedGroup.label;
          const caps = Array.from(new Set(selectedGroup.members.map(p => phoneProfiles[p.profile].max)));
          if (caps.length > 1 && result.limit) result.limit = caps.every(cap => cap > 0) ? 'Plafond du téléphone : de ' + Math.min(...caps) + ' à ' + Math.max(...caps) + ' W selon le modèle.' : '';
          if (selectedGroup.note) result.next += ' ' + selectedGroup.note;
        }
        const target = find('[data-phone-result]');
        target.dataset.compatibility = result.status;
        const title = result.title;
        const phone = phoneCatalogue.find(phone => phone.id === fitState.model);
        const needsCase = result.title.includes('Coque') || result.title.includes('coque');
        const stateIcon = fitDrawing(['compatible','requires-case'].includes(result.status) ? 'check' : ['incompatible','not-recommended'].includes(result.status) ? 'no' : 'verify');
        stateIcon.dataset.fitResultIcon = '';
        const phoneDrawing = fitDrawing(selectedGroup?.drawing || (phone ? phone.brand === 'Apple' ? shapeOf(phone) : phone.brand.toLowerCase() : 'unknown'));
        phoneDrawing.dataset.fitResultPhone = '';
        const device = element('div', '', 'sm-fit-device');
        device.append(phoneDrawing, element('p', result.name));
        question.textContent = title;
        target.replaceChildren(stateIcon);
        if (result.status === 'requires-case') {
          const condition = element('p', '', 'sm-fit-condition');
          condition.dataset.fitCondition = '';
          const attention = element('span', '!', 'sm-fit-attention');
          attention.setAttribute('aria-hidden', 'true');
          condition.append(attention, element('span', result.magnet));
          target.append(condition);
        }
        target.append(device);
        if (result.status === 'compatible' || result.status === 'requires-case') {
          target.append(element('p', '' + productLabel + ' ' + result.recommendation, 'sm-fit-recommendation'));
          target.append(element('p', 'La version recommandée pour votre téléphone.', 'sm-fit-subtitle'));
          if (result.limit) target.append(element('small', result.limit));
        }
        if (result.status !== 'requires-case' && (result.status === 'compatible' || needsCase || fitState.caseType === 'unknown')) {
          const card = element('div', '', 'sm-fit-case-card');
          card.append(fitDrawing(fitState.caseType === 'none' ? 'bare' : fitState.caseType === 'qi2-ready' ? 'qi2-ready' : 'magnetic'), element('p', result.magnet));
          target.append(card);
        }
        if (result.status === 'incompatible' && !needsCase) target.append(element('p', 'Ce téléphone ne possède pas la charge sans fil Qi. Choisissez une solution de charge filaire.'));
        else if (result.status === 'not-recommended') target.append(element('p', result.next));
        if ((result.status === 'requires-case' || phone?.profile === 'iphone-qi-no-magnets') && result.next && !result.next.startsWith('Adaptez votre coque avant d’utiliser le ' + productLabel + '.')) target.append(element('small', result.next));
        if (result.usage) target.append(element('small', result.usage));
        if (selectedGroup?.id === 'apple-16-plus') target.append(element('small', 'iOS 26 ou plus récent requis pour la capacité Qi2 25 W.'));
        if (result.status === 'compatible' || result.status === 'requires-case') {
          const first = chosenUnit(0);
          const colour = colorOf(first.product.handle === primaryHandle ? first.variant : defaultVariant);
          const matching = variant => variant.available && powerOf(variant).replace(/\s/g, '') === result.recommendation.replace(/\s/g, '');
          const recommended = firstProduct.variants.find(variant => matching(variant) && colorOf(variant) === colour) || firstProduct.variants.find(matching);
          const available = recommended || firstProduct.variants.find(variant => variant.available && colorOf(variant) === colour) || firstProduct.variants.find(variant => variant.available);
          const choose = element('button', recommended ? 'Choisir ' + productLabel + ' ' + result.recommendation.replace(' ', '\u00a0') : available ? 'Voir les versions disponibles' : '' + productLabel + ' indisponible', 'sm-button');
          choose.type = 'button';
          choose.disabled = !available;
          if (!recommended) target.append(element('p', 'La version recommandée est actuellement indisponible.'));
          choose.addEventListener('click', () => { if (!available) return; units[0] = available.id; fit.close(); form.requestSubmit(); });
          target.append(choose);
        }
      }
      if (focus) {
        fit.scrollTop = 0;
        question.focus({ preventScroll: true });
      }
    }
    find('[data-fit-back]').addEventListener('click', () => { if (fitHistory.length) { fitState = fitHistory.pop(); renderFit(true); } });
    renderFit();
    const gallery = find('[data-gallery]');
    const gallerySlides = Array.from(gallery.querySelectorAll('.sm-gallery-slide'));
    const galleryIndex = () => Math.round(gallery.scrollLeft / gallery.clientWidth);
    function setGallery(index) {
      if (!gallerySlides.length) return;
      gallery.scrollTo({ left: ((index + gallerySlides.length) % gallerySlides.length) * gallery.clientWidth });
    }
    page.querySelectorAll('[data-thumb]').forEach((button, index) => button.addEventListener('click', () => setGallery(index)));
    page.querySelectorAll('[data-gallery-step]').forEach(button => button.addEventListener('click', () => setGallery(galleryIndex() + Number(button.dataset.galleryStep))));
    const galleryCallout = find('.sm-gallery-callout');
    function syncGallery() {
      const activeIndex = galleryIndex();
      galleryCallout.hidden = activeIndex !== 0;
      page.querySelectorAll('[data-thumb]').forEach((button, index) => button.setAttribute('aria-current', String(index === activeIndex)));
    }
    gallery.addEventListener('scroll', syncGallery, { passive: true });
    new ResizeObserver(syncGallery).observe(gallery);
    syncGallery();
    const lightbox = find('#sm-lightbox');
    const lightboxTrack = lightbox.querySelector('[data-lightbox-track]');
    lightboxTrack.replaceChildren(...gallerySlides.map(slide => {
      const item = element('div', '', 'sm-lightbox-slide');
      const source = slide.querySelector('img');
      if (source) {
        const image = source.cloneNode();
        image.draggable = false;
        item.append(image);
      }
      return item;
    }));
    let lightboxIndex = 0;
    function setLightbox(index) {
      const target = (index + gallerySlides.length) % gallerySlides.length;
      const image = gallerySlides[target].querySelector('img');
      if (!image) return false;
      lightboxIndex = target;
      lightboxTrack.scrollTo({ left: target * lightboxTrack.clientWidth, behavior: 'instant' });
      return true;
    }
    page.querySelectorAll('[data-image]').forEach(button => {
      button.disabled = !button.querySelector('img');
      button.addEventListener('click', () => {
        if (!button.querySelector('img')) return;
        lightbox.showModal();
        lightbox.querySelector('[data-close]').focus({ preventScroll: true });
        setLightbox(gallerySlides.indexOf(button));
      });
    });
    function stepLightbox(direction) {
      for (let step = 1; step <= gallerySlides.length; step++) {
        if (setLightbox(lightboxIndex + direction * step)) return;
      }
    }
    page.querySelectorAll('[data-lightbox-step]').forEach(button => button.addEventListener('click', () => stepLightbox(Number(button.dataset.lightboxStep))));
    lightboxTrack.addEventListener('scroll', () => {
      if (lightbox.open && lightboxTrack.clientWidth) lightboxIndex = Math.round(lightboxTrack.scrollLeft / lightboxTrack.clientWidth);
    }, { passive: true });
    new ResizeObserver(() => { if (lightbox.open) setLightbox(lightboxIndex); }).observe(lightboxTrack);
    lightbox.addEventListener('keydown', event => {
      if (!lightbox.open || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
      event.preventDefault();
      stepLightbox(event.key === 'ArrowLeft' ? -1 : 1);
    });
    root.LpcAnneVideo?.mount({ page, gallery, gallerySlides, galleryIndex, lightbox, lightboxTrack, setLightbox });
    const footerMedia = root.matchMedia('(min-width: 750px)');
    const footerMenus = page.querySelectorAll('.sm-footer-menu');
    const syncFooterMenus = () => footerMenus.forEach(menu => {
      menu.open = footerMedia.matches;
      menu.querySelector('summary').tabIndex = footerMedia.matches ? -1 : 0;
    });
    syncFooterMenus();
    footerMedia.addEventListener('change', syncFooterMenus);
    page.querySelectorAll('[data-collapsible-single]').forEach(group => {
      const items = Array.from(group.querySelectorAll('details'));
      items.forEach(item => item.addEventListener('toggle', () => {
        if (item.open) items.forEach(other => { if (other !== item) other.open = false; });
      }));
    });
    page.querySelectorAll('[data-open]').forEach(button => button.addEventListener('click', event => {
      event.preventDefault();
      const dialog = find('#sm-' + button.dataset.open);
      if (button.dataset.open === 'fit') resetFit(false);
      dialog.showModal();
      if (button.dataset.open === 'fit') renderFit(true);
      dialog.addEventListener('close', () => button.focus({ preventScroll: true }), { once: true });
    }));
    page.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => button.closest('dialog').close()));
    page.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } }));
    root.LPCSmoocheRouting.mountGiftOffer({ page, form, configurator, document });
    page.querySelector('[data-latch-close]').addEventListener('click', () => find('.sm-newsletter-latch-wrap').hidden = true);
    const halloween = find('[data-halloween]');
    if (halloween) {
      const deadline = Date.parse(halloween.dataset.deadline);
      const tickHalloween = () => {
        const seconds = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
        const expired = !Number.isFinite(deadline) || seconds === 0;
        halloween.hidden = expired;
        find('[data-halloween-fallback]').hidden = !expired;
        const parts = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
        halloween.querySelectorAll('[data-halloween-part]').forEach(part => { part.textContent = String(parts[part.dataset.halloweenPart]).padStart(2, '0'); });
        return expired;
      };
      if (!tickHalloween()) {
        const timer = root.setInterval(() => { if (tickHalloween()) root.clearInterval(timer); }, 1000);
      }
    }
    const countdown = find('[data-simulation-countdown]');
    if (countdown) {
      let seconds = 10 * 60 * 60;
      const reducedMotion = root.matchMedia('(prefers-reduced-motion: reduce)');
      const timer = root.setInterval(() => {
        if (document.hidden || reducedMotion.matches) return;
        seconds--;
        countdown.textContent = [Math.floor(seconds / 3600), Math.floor(seconds / 60) % 60, seconds % 60].map(value => String(value).padStart(2, '0')).join(':');
        if (!seconds) root.clearInterval(timer);
      }, 1000);
    }
    const carouselStep = track => track.children[0].getBoundingClientRect().width + (parseFloat(root.getComputedStyle(track).columnGap) || 0);
    page.querySelectorAll('[data-scroll]').forEach(button => button.addEventListener('click', () => {
      const track = find('#' + button.dataset.scroll);
      track.scrollBy({ left: Number(button.dataset.direction) * carouselStep(track) });
    }));
    const features = find('#sm-features');
    const featureDots = Array.from(page.querySelectorAll('[data-feature-index]'));
    let featureStops = [];
    function syncFeatureDots() {
      const index = featureStops.reduce((closest, position, stopIndex) => Math.abs(position - features.scrollLeft) < Math.abs(featureStops[closest] - features.scrollLeft) ? stopIndex : closest, 0);
      find('[data-feature-counter]').textContent = 'Page ' + (index + 1) + ' sur ' + featureStops.length;
      featureDots.forEach((button, dotIndex) => button.setAttribute('aria-current', String(dotIndex === index)));
    }
    function refreshFeatureStops() {
      featureStops = carouselStops(features.children.length, carouselStep(features), features.scrollWidth - features.clientWidth);
      featureDots.forEach((button, index) => {
        button.hidden = index >= featureStops.length;
        button.setAttribute('aria-label', 'Page ' + (index + 1) + ' sur ' + featureStops.length);
      });
      syncFeatureDots();
    }
    featureDots.forEach((button, index) => button.addEventListener('click', () => {
      if (index < featureStops.length) features.scrollTo({ left: featureStops[index] });
    }));
    features.addEventListener('scroll', syncFeatureDots, { passive: true });
    new ResizeObserver(refreshFeatureStops).observe(features);
    refreshFeatureStops();
    const sticky = find('[data-sticky]');
    let stickyFrame = 0;
    const syncSticky = () => {
      stickyFrame = 0;
      sticky.hidden = form.getBoundingClientRect().bottom > 95;
    };
    const scheduleSticky = () => { if (!stickyFrame) stickyFrame = root.requestAnimationFrame(syncSticky); };
    root.addEventListener('scroll', scheduleSticky, { passive: true });
    root.addEventListener('resize', scheduleSticky);
    new ResizeObserver(scheduleSticky).observe(form);
    syncSticky();
    const timeline = find('.sm-usage-timeline');
    if (timeline && typeof root.IntersectionObserver === 'function' && !root.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const timelineObserver = new root.IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-on');
          timelineObserver.unobserve(entry.target);
        });
      }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
      timeline.querySelectorAll('.sm-timeline-step').forEach(step => timelineObserver.observe(step));
      timeline.classList.add('sm-timeline-motion');
    }
    render();
  }
  if (typeof document !== 'undefined') document.querySelectorAll('[data-smooche]').forEach(mount);

  const api = { quote, galleryTarget, carouselStops, phoneCatalogue, compatibility };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.LPCSmoocheCatalogue = api;
})(typeof window !== 'undefined' ? window : globalThis);
